import { useEffect } from 'react'

export const DONATION_IMAGE_LEAVE_MESSAGE = '선택한 이미지 파일은 저장 전에 이동하면 사라집니다. 이동하시겠습니까?'

export const hasPendingDonationImages = (params = {}) => {
    return params.productImage instanceof File || params.letterBaseImage instanceof File
}

// 업로드 파일은 브라우저 보안상 복구할 수 없어서, 새로고침/탭 닫기 직전에만 기본 경고를 띄운다.
export const usePendingDonationImageUnloadGuard = (enabled) => {
    useEffect(() => {
        if (typeof window === 'undefined' || !enabled) {
            return undefined
        }

        const handleBeforeUnload = (event) => {
            event.preventDefault()
            event.returnValue = ''
            return ''
        }

        window.addEventListener('beforeunload', handleBeforeUnload)

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload)
        }
    }, [enabled])
}
